import { useEffect, useState } from "react";
import { useLocation } from "wouter";
import { apiFetch } from "../lib/api.js";
import { IllustrationSessionIcon } from "../components/illustrations.jsx";

// Row labels and descriptions come verbatim from canon/11 section 10.7,
// button labels from 10.3. Do not edit copy here - change the canon first.
const TYPES = [
  { type: "first", label: "First session", description: "Claim your ground. About an hour, once.", button: "Claim your ground" },
  { type: "weekly", label: "Weekly review", description: "One honest Monday. Score last week, set this one.", button: "Run your review" },
  { type: "reset", label: "Rough round", description: "Get you up. No lecture, no shame. We rebuild from the floor.", button: "Get me up" },
  { type: "quarter", label: "Quarter review", description: "Close the quarter honestly. What held, what did not, what is next.", button: "Close the quarter" },
  { type: "open", label: "Open session", description: "Anything else. Start where you like.", button: "Talk to your corner" },
];

export default function CoachHub() {
  const [, navigate] = useLocation();
  const [sessions, setSessions] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    apiFetch("/sessions").then(setSessions).catch((e) => setError(e.message));
  }, []);

  async function start(type) {
    setError(null);
    try {
      const session = await apiFetch("/sessions", { method: "POST", body: { type } });
      if (session.starterMessage) {
        sessionStorage.setItem(`coach-starter-${session.id}`, session.starterMessage);
      }
      navigate(`/coach/${session.id}`);
    } catch (e) {
      setError(e.message);
    }
  }

  return (
    <div className="page">
      <div className="kicker" style={{ marginBottom: 12 }}>
        <span className="the-line" />
        YOUR CORNER
      </div>
      <h1 style={{ marginBottom: 32 }}>Start a session</h1>

      <div className="card-grid" style={{ gridTemplateColumns: "1fr" }}>
        {TYPES.map((t) => (
          <div key={t.type} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 16 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
              <IllustrationSessionIcon type={t.type} />
              <div>
                <div className="card-title" style={{ marginBottom: 4 }}>{t.label}</div>
                <div style={{ color: "var(--muted)", fontSize: 14 }}>{t.description}</div>
              </div>
            </div>
            <button className="btn-secondary" onClick={() => start(t.type)}>{t.button}</button>
          </div>
        ))}
      </div>

      {error && <p style={{ color: "var(--error)", marginTop: 16 }}>{error}</p>}

      {sessions.length > 0 && (
        <div style={{ marginTop: 48 }}>
          <div className="kicker" style={{ marginBottom: 16 }}>
            <span className="the-line" />
            PAST SESSIONS
          </div>
          <div className="hairline-list">
            {sessions.map((s) => (
              <div key={s.id} style={{ display: "flex", justifyContent: "space-between" }}>
                <a href={`/coach/${s.id}`} onClick={(e) => { e.preventDefault(); navigate(`/coach/${s.id}`); }}>
                  {TYPES.find((t) => t.type === s.type)?.label || s.type}
                </a>
                <span style={{ color: "var(--muted)", fontSize: 13 }}>
                  {new Date(s.startedAt).toLocaleDateString()} {s.ended ? "· ended" : ""}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
